import { ChartConfiguration } from "chart.js";
import { backgroundColorLighter } from "~/variables";
import { $t } from "~/i18n";

export const config: ChartConfiguration<'bar'> = {
    type: 'bar',
    data: {
        datasets: [],
    },
    options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                stacked: true,
                suggestedMin: 0,
                suggestedMax: 5,
                ticks: { color: 'white', maxTicksLimit: 6},
                display: true,
                grid: {
                    display: true,
                    color: backgroundColorLighter,
                },
                title: {
                    display: true,
                    align: 'center',
                    text: $t('alarm_chart.scale.y.title'),
                    color: 'white',
                },
            },
            x: {
                stacked: true,
                offset: true,
                // time: {
                //     unit: this.mode === '6month' ? 'month':'day',
                //     displayFormats: {
                //         day: 'MMMM YY',
                //         month: 'MMMM YY'
                //     },
                //     tooltipFormat:'ll',
                // },
                grid: {
                    display: true,
                    color: backgroundColorLighter
                },
                ticks: {
                    maxRotation: 0,
                    color: 'white',
                    maxTicksLimit: 8,
                }
            }
        },
        plugins: {
            legend: {
                display: true,
            },

            zoom: {
                pan: {
                    enabled: true,
                    mode: 'x',
                    modifierKey: 'ctrl',
                },
                zoom: {
                    mode: 'x',
                    drag: {
                        enabled: true,
                        borderColor: 'rgb(54, 162, 235)',
                        borderWidth: 1,
                        backgroundColor: 'rgba(54, 162, 235, 0.3)'
                    },
                }
            },
        }
    }
}